import React, { useRef } from "react";
import { Link } from "react-router-dom";

function Calculator(props) {
  const calculator = useRef();
  // const linkroute = useCallback(
  //   () => history.push(props.calculator.route),
  //   [history]
  // );
  const handleClick = (e) => {
    if (!calculator.current?.contains(e.target)) {
      if (calculator.current) {
        calculator.current.style = "box-shadow: none;transform: scale(1);";
      }
    }
  };

  window.addEventListener("mousedown", handleClick, false);

  window.addEventListener("scroll", () => {
    if (calculator.current) {
      calculator.current.style = "box-shadow: none;transform: scale(1);";
    }
  });
  return (
    <>
      <div
        className={`col-12 col-md-4 col-lg-4 mt-3 px-2 shadowCol mb-3 ${props.className}`}
        data-category={props.calculator.category}
      >
        <div
          ref={calculator}
          className="calculator position-relative"
          id={props.calculator.name}
        >
          <h5 className="text-center">{props.calculator.name}</h5>
          <div className="overflow-auto">
            <p className="calc-box"> {props.calculator.content}</p>
          </div>
          {/* <button
            className="btn d-flex justify-content-center"
            onClick={() => linkroute()}
          >
            <i class="bx bxs-calculator" style={{ fontSize: "1.4rem" }}></i>
          </button> */}
          <Link
            to={props.calculator.route}
            className="btn d-flex justify-content-center"
          >
            <i className="bx bxs-calculator" style={{ fontSize: "1.4rem" }}></i>
          </Link>
        </div>
      </div>
    </>
  );
}

export default Calculator;
